import React from 'react';
import * as PropTypes from 'prop-types';
import styles from '../DerouleArmeComponent.module.scss';

const DerouleArmeElementArmeComponent = ({ elementArme }) => (
    <div className={styles['DerouleArme-element']}>
        <div className={styles['DerouleArme-labelElement']}>{elementArme.libelleType}</div>
        <div>Numéro de série :</div>
        <div className={styles['DerouleArme-labelElement']}>{elementArme.numeroSerie}</div>
        <div>Numéro d&apos;encodage :</div>
        <div className={styles['DerouleArme-labelElement']}>{elementArme.numeroEncodage}</div>
    </div>
);

DerouleArmeElementArmeComponent.defaultProps = {
    elementArme: null,
};

DerouleArmeElementArmeComponent.propTypes = {
    elementArme: PropTypes.shape({
        libelleType: PropTypes.string.isRequired,
        numeroSerie: PropTypes.string.isRequired,
        numeroEncodage: PropTypes.string.isRequired,
    }),
};

export default DerouleArmeElementArmeComponent;
